export default __webpack_public_path__ + "static/media/team-claudia.5a0b1e07.webp";